module.exports = __webpack_public_path__ + "static/media/Ooppah_Clube_Faculdade_Cesgranrio.92d1d42f.pdf";